import { Icon } from "@iconify/react/dist/iconify.js";

const VARIANT_CLASSES = {
  success: "alert-success",
  error: "alert-danger",
  warning: "alert-warning",
  info: "alert-primary",
};

const VARIANT_ICONS = {
  success: "mdi:check-circle-outline",
  error: "mdi:alert-circle-outline",
  warning: "mdi:alert-outline",
  info: "mdi:information-outline",
};

const SIZE_CLASSES = {
  sm: "py-2 px-3 text-sm",
  md: "py-3 px-4",
  lg: "py-4 px-5 text-lg",
};
const Alert = ({ message, variant = "error", onClose, size = "sm" }) => {
  if (!message) return null;

  return (
    <div
      className={`alert ${VARIANT_CLASSES[variant]} ${SIZE_CLASSES[size]} 
      d-flex align-items-center justify-content-between radius-8 mb-16`}
      role="alert"
    >
      <div className="d-flex align-items-center gap-2">
        <Icon icon={VARIANT_ICONS[variant]} width="22" />
        <span>{message}</span>
      </div>

      {onClose && (
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
        />
      )}
    </div>
  );
};

export default Alert;
